<template>
<div class="chapter">
<div class="inner_page">
<p class="center-4"><span>To</span></p>
<p class="center-1"><span>EVE</span></p>
<p class="center-1"><span>these memorials of her native city</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_ded.vue?13ee4a93